import type { UnitNumberCheckQuoteFormInput } from 'app/home/create-quote/forms/unit-number-check/unit-number-check.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function unitNumberCheckQuoteFormSelector(store: QuoteDraftSelectorState): UnitNumberCheckQuoteFormInput {
  const hasUnitNumber = store.hasUnitNumber();
  return { hasUnitNumber };
}

export function unitNumberCheckQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['unit-number-check']();
}
